import { useMutation, useQueryClient } from "@tanstack/react-query";
import React, { useState } from "react";
import { archiveInventory } from "src/api/inventory";
import { renderCurrency, showSuccessToast } from "src/lib/utils";
import CustomConfirmDialog from "../CustomConfirmDialog";
import EditProductModal from "./EditProductModal";
import { usePortalContext } from "src/context/PortalContext";

const ProductDetailModal = ({ product }) => {
	const [isEditOpen, setIsEditOpen] = useState(false);

	return isEditOpen ? <EditProductModal product={product} /> : <Details product={product} setIsEditOpen={setIsEditOpen} />;
};

const Details = ({ product, setIsEditOpen }) => {
	const queryClient = useQueryClient();
	const closePortal = usePortalContext();

	const { mutate, isLoading } = useMutation(archiveInventory, {
		onSuccess: () => {
			showSuccessToast("Product archived successfully");
			queryClient.invalidateQueries(["inventory"]);
			closePortal();
		},
	});

	return (
		<div className="mb-4 tw-flex tw-flex-col">
			<div className="modal_cont_sect">
				<img className="product-img" src={product.image} alt="" />
			</div>

			<div className="modal_cont_sect">
				<div className="cont_sect_itm">
					<p>Item Code:</p>
					<p>{product.item_id || "N/A"}</p>
				</div>

				<div className="cont_sect_itm">
					<p>Product Name:</p>
					<p>{product.name || "N/A"}</p>
				</div>

				<div className="cont_sect_itm">
					<p>SKU:</p>
					<p>{product.sku || "N/A"}</p>
				</div>

				<div className="cont_sect_itm">
					<p>Available Quantity:</p>
					<p>{product.available_qty}</p>
				</div>

				<div className="cont_sect_itm">
					<p>Cost Price:</p>
					<p>{renderCurrency(product.cost_price)}</p>
				</div>

				<div className="cont_sect_itm">
					<p>Selling Price:</p>
					<p>{renderCurrency(product.price)}</p>
				</div>
				<div className="modal_cont_sect">
					<div className="pb-2 inv_totals">
						<h4 className="tw-font-bold">Description</h4>
						<p>{product.description || "No description available"}</p>
					</div>
				</div>
			</div>

			<div className="tw-grid tw-grid-cols-2 tw-gap-4 tw-mt-auto">
				<button className="blue-btn" onClick={() => setIsEditOpen(true)}>
					Edit Product
				</button>

				<CustomConfirmDialog
					trigger={
						<button disabled={isLoading} className="orange-btn">
							Archive Product
						</button>
					}
					mutateFn={() => mutate({ uuid: product.uuid })}
				/>
			</div>
		</div>
	);
};

export default ProductDetailModal;
